<template></template>

<script>
  export default {
    props: ['id'],
    created () {
      this.changeLang()
    },
    methods: {
      changeLang () {
        if (this.id === 'fi' || this.id === 'se' || this.id === 'en') {
          this.$store.commit('setLocale', this.id)
        }
        this.$router.push('/')
      }
    }
  }
</script>
